import { cloneDeep, isEmpty } from "lodash";

import PropTypes from "prop-types";
import React from "react";
import SolutionsComponent from "./SolutionsComponent";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchContact } from "../../redux/actions";
import { getUserInfo } from "../../redux/selectors";
import { requesterEmailAddress } from "../../libs/utils";

class SolutionsContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      contact: this.props.contact,
      originalContact: null,
      originalSubscription: null,
    };
  }

  componentDidMount() {
    document.title = "User Profile - IPD Solutions";
    const emailAddress = requesterEmailAddress(this.props);
    this.props.fetchContact(emailAddress);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEmpty(nextProps.contact) &&
      isEmpty(prevState.originalSubscription) &&
      isEmpty(prevState.originalContact)
    ) {
      return {
        contact: nextProps.contact,
        originalSubscription: cloneDeep(nextProps.contact.subscription),
        originalContact: cloneDeep(nextProps.contact),
      };
    }
    return {
      contact: nextProps.contact,
      originalSubscription: prevState.originalSubscription,
      originalContact: prevState.originalContact,
    };
  }

  render() {
    const { contact } = this.state;
    return (
      <SolutionsComponent
        contact={contact}
        subscription={
          isEmpty(contact) || isEmpty(contact.subscription)
            ? null
            : contact.subscription
        }
      />
    );
  }
}

SolutionsContainer.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  contact: PropTypes.object,
};

const mapStateToProps = (state) => ({
  emailAddress: getUserInfo(state).emailAddress,
  contact: getUserInfo(state).contact,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchContact,
    },
    dispatch
  );

const SolutionsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(SolutionsContainer);

export default SolutionsConnect;
